module.exports = __webpack_public_path__ + "img/Mano.3aa19233.svg";